import PostEditor from "../../templates/PostEditor";

const NewPost = () => {
  return <PostEditor isEdit={false} />;
};

export default NewPost;
